import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { BrandLogo } from "@/components/Brand";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="mt-24 bg-brand-navy text-canvas-cream" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="mb-4 bg-white inline-block rounded-2xl p-3">
            <BrandLogo />
          </div>
          <p className="text-sm text-canvas-cream/75 max-w-md leading-relaxed">
            {t("hero.subtitle")}
          </p>
        </div>
        <div>
          <h4 className="text-brand-gold font-serif text-xl mb-4">
            {t("nav.contact")}
          </h4>
          <ul className="space-y-2 text-sm text-canvas-cream/80">
            <li className="flex items-center gap-2"><Phone size={14} className="text-brand-orange"/> +90 555 000 00 00</li>
            <li className="flex items-center gap-2"><Mail size={14} className="text-brand-orange"/> info@ariaf.com</li>
            <li className="flex items-center gap-2"><MapPin size={14} className="text-brand-orange"/> Makkah</li>
            <li className="flex items-center gap-2"><Instagram size={14} className="text-brand-orange"/> @ariafcatering</li>
          </ul>
        </div>
        <div>
          <h4 className="text-brand-gold font-serif text-xl mb-4">
            {t("nav.home")}
          </h4>
          <ul className="space-y-2 text-sm text-canvas-cream/80">
            <li><Link to="/gallery" className="hover:text-brand-orange">{t("nav.gallery")}</Link></li>
            <li><Link to="/menu" className="hover:text-brand-orange">{t("nav.menu")}</Link></li>
            <li><Link to="/hotels" className="hover:text-brand-orange">{t("nav.hotels")}</Link></li>
            <li><Link to="/recipes" className="hover:text-brand-orange">{t("nav.recipes")}</Link></li>
            <li><Link to="/admin/login" className="hover:text-brand-orange" data-testid="footer-admin-link">{t("nav.admin")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-canvas-cream/60">
          <div>© {new Date().getFullYear()} Ariaf Catering. {t("footer.rights")}</div>
          <div>{t("footer.made_with")}</div>
        </div>
      </div>
    </footer>
  );
}
